import "./styles.css";
let todayImage = document.querySelector("#today-image");
let todayCity = document.querySelector("#today-city");
let todayConditions = document.querySelector("#today-conditions");
let todayTemp = document.querySelector("#today-temp");
let todayHumidity = document.querySelector("#today-humidity");
let dayTemplate = document.querySelector("#day-row");
let dataContainer = document.querySelector("#data-container");
let searchInput = document.querySelector("#location-input");
let form = document.querySelector("form");

let body = document.querySelector("body");

let errorMessagesContainer = document.querySelector("#error-messages");

const API_KEY = "6ADNTZ5NX2LPKTGXLR9FFL6DT";

async function fetchWeatherData(location = "Bogota") {
  try {
    let response = await fetch(
      "https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/" +
        location +
        "?unitGroup=metric&key=" +
        API_KEY,
    );
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    let weatherData = await response.json();

    return weatherData;
  } catch (error) {
    console.error(error);
  }
}

async function getWeatherAt(location) {
  let apiData = await fetchWeatherData(location);
  let data = {
    location: apiData.address,
    today: apiData.currentConditions,
    days: apiData.days,
  };

  return data;
}

async function updateData(location) {
  errorMessagesContainer.textContent = "Loading..";

  try {
    let data = await getWeatherAt(location);

    updateTodayData(data);
    updateForecast(data);
    errorMessagesContainer.textContent = null;
  } catch (error) {
    errorMessagesContainer.textContent = "Error";
  }
}

function updateTodayData(data) {
  todayCity.textContent = data.location;
  todayConditions.textContent = data.today.conditions;
  todayTemp.textContent = data.today.temp;
  todayHumidity.textContent = data.today.humidity;

  body.className = "";
  switch (data.today.conditions) {
    case "Partially cloudy":
      body.classList.add("partially-cloudy");
      break;
    case "Rain, Partially cloudy":
      body.classList.add("rain-partially-cloudy");
      break;
    case "Clear":
      body.classList.add("clear");
      break;
    case "Overcast":
      body.classList.add("overcast");
      break;
    case "Rain, Overcast":
      body.classList.add("rain-overcast");
      break;
    default:
      body.classList.add("clear");
  }

  // imagine we had a method to get language from cookies or other storage
  import(`./icons/${data.today.icon}.png`).then((image) => {
    todayImage.src = image.default;
  });
}

function updateForecast(data) {
  dataContainer.replaceChildren();
  data.days.forEach((day) => {
    const clone = document.importNode(dayTemplate.content, true);

    let date = clone.querySelector("#date");
    let conditions = clone.querySelector("#conditions");
    let temp = clone.querySelector("#temp");
    let humidity = clone.querySelector("#humidity");
    let icon = clone.querySelector("#image");
    date.textContent = day.datetime;
    conditions.textContent = day.conditions;
    temp.textContent = day.temp;
    humidity.textContent = day.humidity;

    import(`./icons/${day.icon}.png`).then((image) => {
      icon.src = image.default;
    });

    dataContainer.appendChild(clone);
  });
}

form.addEventListener("submit", (e) => {
  e.preventDefault();

  let location = searchInput.value;

  updateData(location);
});

updateData();
